import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ctdl51blev: FaireBrandEntity = {
  token: "b_ctdl51blev",
  type: "brand",
  name: "Muk Luks",
  avatarUrl:
    "https://cdn.faire.com/fastly/b9ad8784e38631ad2e069e178a0d73027f9feb48fff52c41b8551f53a110f530.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/56c50b95db5b8e780a20a7bc930a55918c723afc6dda8107ade770dad121edcb.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b9ad8784e38631ad2e069e178a0d73027f9feb48fff52c41b8551f53a110f530.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/56c50b95db5b8e780a20a7bc930a55918c723afc6dda8107ade770dad121edcb.jpeg",
  location: "Milwaukee, WI, USA",
  minimumOrderDollars: 99,
  rating: 5,
  reviewCount: 80,
  isTopShop: true,
  isInsider: true,
  description:
    "Muk Luks® Slipper Socks were introduced to the world in 1972 by Reliable Knitting Works, a company started by two brothers, Armin and Samuel Rosenberg, in Milwaukee in 1911. The company remained in the family and is currently on its fourth generation – The Polacheck and Blutstein families.\n\nOur philosophy from day one remains strong, “Muk Luks® Lets you wear your way of Life!” - we believe in making product that lets you be you! From cozy sweater knits, to warm metallics, sequins and shine, soft chunky yarns and rich marled textures, there’s a feeling, an atmosphere…a celebration of self-expression and individual beauty.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:16.041Z",
    importedBy: "entity-db-cli",
  },
};
